import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LegacyRouteHandler = () => {
    const { i18n } = useTranslation();
    const location = useLocation();

    // Redirect to the same path but prefixed with the current language, preserving query string
    return <Navigate to={`/${i18n.language}${location.pathname}${location.search}`} replace />;
};

export default LegacyRouteHandler;
